import { createAction } from '@reduxjs/toolkit';
export const updateCompany = createAction('@companies/UPDATE_COMPANY', (payload) => ({ payload }));
